import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { Site } from '../../sites';
import { PRIMARY_OUTLET } from '@angular/router';
import { AdminBuildPart } from './admin-build-part';
import { GlobalPopupBuildPart } from './global-popup-build-part';
import { SiteBuildPart } from './site-build-part';
import { SponsorBuildPart } from './sponsor-build-part';
import { SampleTrackingBuildPart } from './sample-tracking/sample-tracking-build-part';
import { SampleManagementBuildPart } from './sample-management-build-part';

export class EsaBuildPart extends BaseBuildPart {
    constructor(private readonly esaHelperParams: HelperParams) {
        super(esaHelperParams, null, []);
    }

    public admin(): AdminBuildPart {
        return new AdminBuildPart(this.esaHelperParams, this);
    }

    public sponsor(): SponsorBuildPart {
        return new SponsorBuildPart(this.esaHelperParams, this);
    }

    public site(site: Site): SiteBuildPart {
        return new SiteBuildPart(this.esaHelperParams, this, site);
    }

    public globalPopup(): GlobalPopupBuildPart {
        return new GlobalPopupBuildPart(this.esaHelperParams, this);
    }

    public user(): BaseBuildPart {
        return new BaseBuildPart(this.esaHelperParams, this, ['user']);
    }

    public login(): BaseBuildPart {
        return new BaseBuildPart(this.esaHelperParams, this, ['login']);
    }

    public sampletracking(): SampleTrackingBuildPart {
        return new SampleTrackingBuildPart(this.esaHelperParams, this);
    }

    public logout(): BaseBuildPart {
        const outlets: { [outletName: string]: string[]; } = {};
        outlets[PRIMARY_OUTLET] = ['logout'];
        outlets[this.outletName] = null;

        return new BaseBuildPart(this.esaHelperParams, this, [{ outlets: outlets }]);
    }

    public terms(): BaseBuildPart {
        return new BaseBuildPart(this.esaHelperParams, this, ['terms-and-conditions']);
    }

    public portaldisclaimer(): BaseBuildPart {
        return new BaseBuildPart(this.esaHelperParams, this, ['disclaimer']);
    }

    public navigateToReturnUrl(): Promise<boolean> {
        const returnUrl = this.esaHelperParams.router.routerState.snapshot.root.queryParams[this.returnUrlQueryKey];

        if (returnUrl) {
            const url = decodeURIComponent(returnUrl);
            return this.esaHelperParams.router.navigateByUrl(url);
        }

        return this.navigate();
    }

    public navigateToUrl(origUrl: string): Promise<boolean> {
        let urlParams = new URLSearchParams(origUrl.split('?')[1]);

        if (urlParams) {
            const returnUrl = urlParams.get(this.returnUrlQueryKey);
            return this.esaHelperParams.router.navigateByUrl(returnUrl);
        }

        const url = decodeURIComponent(origUrl);
        return this.esaHelperParams.router.navigateByUrl(url);
    }

    public sampleManagement(): SampleManagementBuildPart {
        return new SampleManagementBuildPart(this.esaHelperParams, this);
    }
}